import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=a98518f6&scoped=true"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"
import style0 from "./Signature.vue?vue&type=style&index=0&id=a98518f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98518f6",
  null
  
)

export default component.exports